import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";
import { BillNetwork } from "./useBillAirtimeProviders";

/**
 * Electricity discos from the provider-agnostic bills layer (/v3/bills).
 */
function useBillElectricityDiscos(
  options?: QueryObserverOptions<APIResponse<BillNetwork[]>, APIError>
) {
  const {
    data: discos,
    isLoading: fetchingDiscos,
    isError: isDiscosError,
    error: discosError,
  } = useQuery<APIResponse<BillNetwork[]>, APIError>(
    "bills-electricity-discos",
    async () =>
      await get(API_URL_V3 + "/bills/electricity/discos", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    discos: discos?.data || [],
    fetchingDiscos,
    isDiscosError,
    discosError,
  };
}

export default useBillElectricityDiscos;
